import script from "./DeleteSubAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteSubAccountModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteSubAccountModal.vue?vue&type=style&index=0&id=533400ee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533400ee"]])

export default __exports__